import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../../store/SelectionSliceFor';

const entityKey = 'code-repositories';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

export const CodeRepositoriesReducer = combineReducers({
    selection: selectionSlice.reducer,
});
